import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { UTILS } from "utils";

import AppContainer from "components/ui/AppContainer";
import AppModal from "components/ui/AppModal";
import GroupModifierForm from "./components/GroupModifierForm";
import AttachModifierWithGroup from "./components/AttachModifierWithGroup";
import useGroupModifierApi from "./useGroupModifierApi";
import { validateInputs } from "./validate";

const initialValues = {
  values: {
    isSingleSelection: false,
    maximumAllowedSelection: 0,
    minimumAllowedSelection: 0,
    baseLanguage: {
      name: "",
    },
    translations: {
      en: {
        name: "",
      },
      ar: {
        name: "",
      },
    },
  },
  errors: {
    minimumAllowedSelection: "",
    maximumAllowedSelection: "",
    baseLanguage: {
      name: "",
    },
    isSingleSelection: "",
  },
};

const CreateModifierGroup = (
  { as = "create", onSuccess = () => { }, onClose = () => { }, open = false,  
  title = "Create Modifier Group",
  subTitle = "Group Modifiers under the same section" },
 
) => {
  const { t } = useTranslation();
  const [toBeAttachedModifiersOptions, setToBeAttachedModifiersOptions] =
    useState([]);
  const [modifierGroup, setModifierGroup] = useState(initialValues);

  const setError = (obj) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      errors: obj,
    }));
  };

  const { loading, addNewModifierGroup } = useGroupModifierApi({
    as,
    onSuccess,
    onClose,
    open,
    toBeAttachedModifiersOptions,
  });

  const handleValues = (key, val) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const handleText = (key, val) => {
    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        baseLanguage: {
          [key]: val,
        },
        translations: {
          en: {
            name: val,
          },
          ar: {
            name: val,
          },
        },
      },
      errors: {
        ...prevState.errors,
        baseLanguage: {
          [key]: "",
        },
      },
    }));
  };

  const handleSelection = (key, val) => {
    modifierGroup.values.maximumAllowedSelection = 1;

    setModifierGroup((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: val === "single" ? true : false,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };

  const updatePrice = (key, val) => {
    const value = UTILS.NumberConversion(val);
    let Num = Number(value);
    handleValues(key, Num);
  };

  const Tag = as === "modal" ? AppModal : AppContainer;

  return (
    <Tag
      title={title}
      subTitle={subTitle}
      loading={loading}
      {...(as === "modal" && { onClose: onClose, open: open })}
    >
      <GroupModifierForm
      as={as}
      showBackButton={as === "modal" ? false : true}
        modifierGroup={modifierGroup}
        handleText={handleText}
        handleSelection={handleSelection}
        updatePrice={updatePrice}
        onSave={() => {
          const { isValid } = validateInputs(modifierGroup, setError, t);
          addNewModifierGroup(isValid, modifierGroup.values);
        }}
        content={
          <AttachModifierWithGroup
            toBeAttachedModifiers={toBeAttachedModifiersOptions}
            setToBeAttachedModifiers={setToBeAttachedModifiersOptions}
          />
        }
      />
    </Tag>
  );
};

export default CreateModifierGroup;
